const createImage = (url: string) =>
	new Promise((resolve, reject) => {
		const image = new Image();
		image.addEventListener("load", () => resolve(image));
		image.addEventListener("error", error => reject(error));
		image.setAttribute("crossOrigin", "anonymous");
		image.src = url;
	});

export async function getCroppedImg({
	imageSrc,
	pixelCrop,
	resize,
	imageType = "image/png",
}: {
	imageSrc: string;
	pixelCrop: { [key: string]: any };
	resize: { width: number; height: number };
	imageType: string;
}) {
	const image = await createImage(imageSrc);
	const canvas = document.createElement("canvas");
	const ctx: CanvasRenderingContext2D | null = canvas.getContext("2d");

	canvas.width = resize.width;
	canvas.height = resize.height;

	if (ctx) {
		ctx.drawImage(
			image as CanvasImageSource,
			pixelCrop.x,
			pixelCrop.y,
			pixelCrop.width,
			pixelCrop.height,
			0,
			0,
			resize.width,
			resize.height,
		);
	}

	return new Promise(resolve => {
		canvas.toBlob((file: Blob | null) => {
			if (file) {
				resolve({
					resizeFile: file,
					resizeUrlImage: URL.createObjectURL(file),
				});
			}
		}, imageType);
	});
}
